export const environment = {
  production: false,
  SMART_API_URL: 'https://www.scientialabspruebas.xyz/smartfondos/api/',
};
